const styles = () => ({
  box: {
    borderTop: '1px dashed #555',
    borderBottom: '1px dashed #555',
    height: '33.333%',
    '&:first-child': {
      borderBottom: 'none',
      borderTop: '1px solid #333'
    },
    '&:last-child': {
      borderTop: 'none',
      borderBottom: '1px solid #333'
    }
  }
})

export default styles
